<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6" class="text-center">
        <h1 class="display-4 font-weight-black primary--text mb-4">404</h1>
        <h2 class="display-2 font-weight-bold mb-6">Halaman Tidak Ditemukan</h2>
        <p class="headline grey--text text--darken-2 mb-10">
          Maaf, halaman yang Anda cari tidak tersedia atau telah dipindahkan ke alamat lain.
        </p>
        <v-btn x-large color="primary" class="px-10 rounded-lg elevation-4" @click="goHome">
          <v-icon left>mdi-home</v-icon>
          Kembali ke Beranda
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'NotFound',
  methods: {
    goHome() {
      this.$router.push({ name: 'home' });
    },
  },
};
</script>

<style scoped>
.display-4 {
  font-size: 8rem !important;
  letter-spacing: -0.2rem !important;
}
</style>
